export default "__VITE_ASSET__baeda38c__"